import React from 'react'

const localStorageMock = (function () {
  let store = {}

  return {
    getItem: function (key) {
      return store[key] || null
    },
    setItem: function (key, value) {
      store[key] = value.toString()
    },
    removeItem: function (key) {
      delete store[key]
    },
    clear: function () {
      store = {}
    },
    getStore: function () {
      return store
    },
  }
})()

export function mockLocalStorage() {
  Object.defineProperty(window, 'localStorage', {
    value: localStorageMock,
  })
}

export const createGqlResponseTransformer =
  <T,>(queryType: string, typename: string, defaultData: T) =>
  (data: Partial<T> = {}) => ({
    [queryType]: { ...defaultData, ...data, __typename: typename },
  })

export const createSerialTestObjectArray = <T extends Record<string, string>>(
  length: number,
  baseObj: T,
  transformer?: (obj: any) => any
) =>
  Array.from({ length }, (v, i) => {
    let serialObj: Record<string, string> = {}
    for (let key in baseObj) {
      serialObj[key] = baseObj[key] + (i + 1)
    }
    return transformer?.(serialObj) ?? serialObj
  })

const renderNodes = reactNodes => {
  const hasChildren = node => node && (node.children || (node.props && node.props.children))

  const getChildren = node =>
    node && node.children ? node.children : node.props && node.props.children

  if (typeof reactNodes === 'string') {
    return reactNodes
  }

  return Object.keys(reactNodes).map((key, i) => {
    const child = reactNodes[key]
    const isElement = React.isValidElement(child)

    if (typeof child === 'string') {
      return child
    }
    if (hasChildren(child)) {
      const inner = renderNodes(getChildren(child))
      return React.cloneElement(child, { ...child.props, key: i }, inner)
    }
    if (typeof child === 'object' && !isElement) {
      return Object.keys(child).reduce((str, childKey) => `${str}${child[childKey]}`, '')
    }

    return child
  })
}

export const MockTrans = ({ children }) =>
  Array.isArray(children) ? renderNodes(children) : renderNodes([children])
